import { useLocation } from "react-router-dom";

import React, {
    useCallback, useEffect
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import StoryPlayer from '@mlb/react-patterns/components/StoryPlayer';
import { AnimateFrom } from '@mlb/react-patterns/components/AnimatedModal/animatedModal.types';

import {
    useBasePath, useLang
} from '../../hooks/config';

import ModalContainer from '../../containers/Modal';

import { useMediaConfig } from '../../hooks/config';

const AmpPlayer = styled(StoryPlayer)`
    width: 100vw;
    height: 100vh;
`;
const likeButtonConfig = {
    name: 'like',
    backgroundImageUrl: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIzLjAzMDkgMTYuNzIwNEwyMy40ODcyIDE3LjIxMzdMMjMuOTgwNSAxNi43MjEyQzI1LjM1NzcgMTUuMzc4OSAyNy4yNjUyIDE0Ljc2OCAyOS4xMzk5IDE1LjA4MDFDMzEuOTcyMyAxNS41NTIgMzQuMDQ4NCAxOC4wMDMgMzQuMDQ4NCAyMC44NzY2VjIxLjExNUMzNC4wNDg0IDIyLjgyMTEgMzMuMzQxMyAyNC40NTMyIDMyLjA5MTYgMjUuNjE2NkwyNC42NjMgMzIuNTUxOUMyNC4zNTQ2IDMyLjgzOTcgMjMuOTQ3NiAzMyAyMy41MjQyIDMzQzIzLjEwMDggMzMgMjIuNjkzOCAzMi44Mzk3IDIyLjM4NTUgMzIuNTUxOUwxNC45NTY0IDI1LjYxNjZDMTMuNzA4MyAyNC40NTMyIDEzIDIyLjgyMTEgMTMgMjEuMTE1VjIwLjg3NjZDMTMgMTguMDAzIDE1LjA3NjkgMTUuNTUyIDE3LjkwODYgMTUuMDgwMUMxOS43NDYyIDE0Ljc2OCAyMS42OTA3IDE1LjM3ODkgMjMuMDMwOSAxNi43MjA0QzIzLjAzMDkgMTYuNzIwOCAyMi45OTM5IDE2LjcyMDQgMjMuMDMwOSAxNi43MjA0Wk0yMy40ODcyIDIwLjAwNTFMMjEuNjM3MiAxOC4wODExQzIwLjc0NTIgMTcuMjI1MiAxOS40NzkgMTYuODE5IDE4LjIzMzMgMTcuMDI2MkMxNi4zNTI1IDE3LjMzOTkgMTQuOTczMyAxOC45NjkxIDE0Ljk3MzMgMjAuODc2NlYyMS4xMTVDMTQuOTczMyAyMi4yNzQ0IDE1LjQ1NDcgMjMuMzg0MyAxNi4zMDI4IDI0LjE3MzZMMjMuNTI0MiAzMC45MTU3TDMwLjc0NzMgMjQuMTczNkMzMS41OTQxIDIzLjM4NDMgMzIuMDc1MSAyMi4yNzQ0IDMyLjA3NTEgMjEuMTE1VjIwLjg3NjZDMzIuMDc1MSAxOC45NjkxIDMwLjY5MzggMTcuMzM5OSAyOC44MTUxIDE3LjAyNjJDMjcuNTY5NCAxNi44MTkgMjYuMzAzMyAxNy4yMjUyIDI1LjQxMTIgMTguMDgxMUwyMy40ODcyIDIwLjAwNTFaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K',
    position: 'end',
};
const playerConfig = {};

const Modal = ({
    stories,
    currentStoryUrl,
    onClose,
    playlist,
}) => {

    const basePath = useBasePath();
    const { stories: storiesConfig = {} } = useMediaConfig();
    const {
        pathname = "",
        search = "",
        hash = "",
    } = useLocation();
    const hostPath = `${basePath}${pathname}${search}${hash}`;
    const lang = useLang();

    const {
        showLike = false,
        disablePlaybackUrlOverride = false,
    } = storiesConfig;

    const updateHistoryState = useCallback((url) => {

        try {

            window?.history?.replaceState(null, '', url);

        } catch {

            window?.history?.replaceState(null, '', hostPath);

        }

    }, [hostPath]);

    const onCloseHandler = useCallback((event) => {

        updateHistoryState(hostPath);
        onClose(event);

    }, [
        onClose,
        updateHistoryState,
        hostPath,
    ]);

    const navigationHandler = useCallback((event) => {

        updateHistoryState(event.detail.href);

    }, [updateHistoryState]);

    if (showLike) {

        playerConfig.controls = [likeButtonConfig];

    }

    return (
        <ModalContainer
            isOpen={!!currentStoryUrl}
            animate={true}
            animateFrom={AnimateFrom.BOTTOM}
            animationDuration={0.3}
            customHeader={<></>}
        >
            <AmpPlayer
                config={playerConfig}
                currentStoryUrl={currentStoryUrl}
                lang={lang}
                stories={stories}
                onClose={onCloseHandler}
                onNavigation={navigationHandler}
                onNoNextStory={onClose}
                exitControl="close"
                disablePlaybackUrlOverride={disablePlaybackUrlOverride}
                playlist={playlist}
                referrer={`${basePath}/`}
            />
        </ModalContainer>
    );

};

Modal.propTypes = {
    stories: PropTypes.array.isRequired,
    currentStoryUrl: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    playlist: PropTypes.string.isRequired,
};

export default Modal;
